var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelpBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 13.9777 18 12.9786 12.043 12.9786 12.043 14.9527 14 14.9527 14 22.9555 11.1277 22.9555 11.1277 24.9296 14 24.9296 14 24.9555 18 24.9555 18 24.9296 21 24.9296 21 22.9555 18 22.9555 18 13.9777ZM16 30C8.26801 30 2 23.732 2 16 2 8.26801 8.26801 2 16 2 23.732 2 30 8.26801 30 16 30 23.732 23.732 30 16 30ZM15.9559 11.0344C17.0848 11.0344 18 10.1193 18 8.99036 18 7.86145 17.0848 6.94629 15.9559 6.94629 14.827 6.94629 13.9119 7.86145 13.9119 8.99036 13.9119 10.1193 14.827 11.0344 15.9559 11.0344Z",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    fill: "#000000",
    fillRule: "evenodd",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpBlack);
export default __webpack_public_path__ + "static/media/icon-help-black.71bd6d70ad300bb859bac9ea77cf27f1.svg";
export { ForwardRef as ReactComponent };